import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md" }
const _hoisted_2 = { class: "trezo-card-content relative" }
const _hoisted_3 = { class: "absolute max-w-[115px] ltr:-right-[10px] rtl:-left-[10px] top-1/2 -translate-y-1/2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("span", { class: "block mb-[5px]" }, " Conversion ", -1)),
      _cache[1] || (_cache[1] = _createElementVNode("h3", { class: "leading-none text-lg md:text-xl mb-[8px]" }, "32.5%", -1)),
      _cache[2] || (_cache[2] = _createElementVNode("span", { class: "inline-block text-xs px-[9px] text-success-700 border border-success-300 bg-success-100 text-sm rounded-[100px]" }, " +1.4% ", -1)),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.isClient)
          ? (_openBlock(), _createBlock(_component_apexchart, {
              key: 0,
              type: "bar",
              height: "130",
              options: _ctx.conversionChart,
              series: _ctx.conversion
            }, null, 8, ["options", "series"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}